import { api } from 'api';
import { tokenStore } from 'global/token.store';

export const getTempAuthCode = async (Api: typeof api): Promise<string | null> => {
  try {
    const response = await Api.get('sso/v0/user/service-user/temp-auth-code', undefined, {
      headers: {
        Authorization: tokenStore.getToken(),
        'X-Sso-Request-Origin': 'WIDGET_ORIGIN',
      },
    });

    return response.payload?.uwSsoTempAuthCode ?? null;
  } catch (err) {
    console.error('Failed to fetch temp auth code', err);
    return null;
  }
};
